import { reactive, ref } from 'vue'

export function useLoadingFlags() {
  const fetching = ref(false)
  const saving = ref(false)
  const deleting = ref(false)
  const loading = ref(false)

  function setFetching(value) {
    fetching.value = value
  }

  function setSaving(value) {
    saving.value = value
  }

  function setDeleting(value) {
    deleting.value = value
  }

  function setLoading(value) {
    loading.value = value
  }

  function resetAll() {
    fetching.value = false
    saving.value = false
    deleting.value = false
    loading.value = false
  }

  return {
    fetching,
    saving,
    deleting,
    loading,
    setFetching,
    setSaving,
    setDeleting,
    setLoading,
    resetAll,
  }
}
